import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  notification,
  Radio,
  Row,
  Select,
} from "antd"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons"
import Upload, { RcFile } from "antd/lib/upload"
import styles from "../filing.module.css"
import axios from "axios"
import { PreviewImgOrPdf } from "../Preview"
import { AXIOS_IP, beforeUploadFile, beforeUploadFileAndImage, customRequest, downloadFile } from "../fileUploadService"
import { selectCredentials } from "../../../app/applicationSlice"

export const TJXMFormModal = (props: {
  visible: boolean
  token: string
  id?: number
  memo?: string
  onOk: () => void
  onCancel: () => void
}) => {
  const credentials: any = useSelector(selectCredentials)
  
  const [form] = Form.useForm()

  const { TextArea } = Input

  const [fileList, setFileList] = useState<any>([]) //备案登记
  const [fileFSList, setFileFSList] = useState<any>([]) //放射

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const [submitVisible, setSubmitVisible] = useState(false)

  //参考模板
  const templateData = {
    fileConfigId: "5",
    fileName: "备案登记表参考模板",
    fileType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    filePath:
      "be1c7e498f0bf47a452397041a1432e8b569c4000e00ab313a3b5afc18d27258.docx",
  }

  // 自定义上传实现
    const customRequestFn = (options: any, type: string) => {
      customRequest(options, AXIOS_IP, (data: any) => {
        const newurl = {
          fileConfigId: data?.configId,
          fileName: data?.name,
          fileType: data?.type,
          filePath: data?.path,
        }
        switch (type) {
          case "DJ":
            setFileList([...fileList, newurl])
            break
        }
        switch (type) {
          case "FS":
            setFileFSList([...fileFSList, newurl])
            break
        }
      })
    }
  
    const handleRemove = (type: string, index: number) => {
      switch (type) {
        case "DJ":
          setFileList(fileList?.filter((v: any, i: number) => i !== index))
          break
        case "FS":
          setFileFSList(fileFSList?.filter((v: any, i: number) => i !== index))
          break
      }
    }
  
  const getData = () => {
      axios({
        url: `${AXIOS_IP}/filingReviewCheckup/detail`,
        headers: {
          "Content-Type": "application/json",
          "His-Auth": props.token,
        },
        withCredentials: false,
        method: "POST",
        data: { id: props.id },
      }).then((res) => {
        const data = res.data.data
        form.setFieldsValue({
          ...data
        })
        setFileList(data?.filingRegistrationFileUrl || [])
        setFileFSList(data?.radioactiveDiagnosisFileUrl || [])
    }).catch((err) => { console.error(err) })
  }
  

  useEffect(() => {
    form.setFieldsValue({
      filingRegistrationFileUrl: fileList,
    })
  }, [fileList])

  useEffect(() => {
    form.setFieldsValue({
      radioactiveDiagnosisFileUrl: fileFSList,
    })
  }, [fileFSList])

  useEffect(() => {
    if (!props.visible) {
      form.resetFields()
      setFileList([])
    } else {
      if(props.id) {
        getData()
      }
    }
  }, [props.visible, props.id])
  return (
    <>
      <Modal
        title="体检项目备案"
        width={1000}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={form.submit}
        okText="提交"
        centered
        maskClosable={false}
        confirmLoading={confirmLoading}
      >
        <div className={styles.filingForm}>
          <Form
            form={form}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            style={{ paddingRight: 10 }}
            initialValues={{
              isClient: 1
            }}
            onFinish={(vs) => {
              setSubmitVisible(true)
            }}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  name="projectCount"
                  label="项目数量"
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="conditionDescription"
                  label="情况说明"
                  rules={[{ required: true }]}
                >
                  <TextArea allowClear showCount maxLength={100} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="备案登记表"
                  name="filingRegistrationFileUrl"
                  rules={[{ required: true, message: "请上传备案登记表" }]}
                >
                  <div>
                    <div style={{ padding: "0px 0px 10px 0px" }}>
                      无锡市健康体检机构项目目录备案登记表，文件格式加盖公章的pdf和图片上传。 
                      <a
                        style={{ textDecoration: "underline", paddingRight: 10 }}
                        onClick={() => downloadFile(templateData, props.token, 'docx')}
                      >
                        参考模板
                      </a>
                    </div>
                    <Upload
                      customRequest={(options) =>
                        customRequestFn(options, "DJ")
                      }
                      beforeUpload={(file) => beforeUploadFileAndImage(file, fileList, 1)}
                      showUploadList={false}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        paddingTop: 10,
                      }}
                    >
                      {fileList?.length > 0 &&
                        fileList?.map((v: any, index: number) => {
                          return (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                paddingRight: 10,
                                paddingTop: 10,
                              }}
                            >
                              <span style={{ paddingRight: 10 }}>
                                {v.fileName}{" "}
                                <a
                                  style={{ paddingLeft: 10 }}
                                  onClick={() => setPreviewFile(v)}
                                >
                                  查看
                                </a>
                              </span>
                              <CloseOutlined
                                style={{
                                  position: "relative",
                                  top: 2,
                                  color: "rgb(161 161 161)",
                                }}
                                onClick={() => {
                                  handleRemove("DJ", index)
                                }}
                              />
                            </div>
                          )
                        })}
                    </div>
                  </div>
                </Form.Item>
              </Col> 
              <Col span={24}>
                <Form.Item
                  label="放射诊疗许可证"
                  name="radioactiveDiagnosisFileUrl"
                >
                  <div>
                    <div style={{ padding: "0px 0px 10px 0px" }}>
                        涉及放射检查项目的还应提供有效的《放射诊疗许可证》扫描件，涉及检查检验外送的还应提供第三方合作协议扫描件。支持pdf和图片文件格式上传。
                    </div>
                    <Upload
                      customRequest={(options) =>
                        customRequestFn(options, "FS")
                      }
                      beforeUpload={(file) => beforeUploadFileAndImage(file, fileFSList)}
                      showUploadList={false}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        paddingTop: 10,
                      }}
                    >
                      {fileFSList?.length > 0 &&
                        fileFSList?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{ paddingRight: 10 }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a
                                style={{ paddingLeft: 10 }}
                                onClick={() => setPreviewFile(v)}
                              >
                                查看
                              </a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("FS", index)
                              }}
                            />
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>

      <Modal
        title="提交申请"
        width={450}
        visible={submitVisible}
        onCancel={() => setSubmitVisible(false)}
        confirmLoading={confirmLoading}
        onOk={() => {
          setConfirmLoading(true)
          const data = {
            ...form.getFieldsValue(),
            applicantId: credentials.userId,
            applicantName: credentials.userName,
            id: props.id,
            memo: props.memo,
          }
          axios({
            url: `${AXIOS_IP}/filingReviewCheckup/createOrUpdate`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": props.token,
            },
            withCredentials: false,
            method: "POST",
            data,
          })
            .then((res) => {
              if (res.data?.data || res.data?.success) {
                setSubmitVisible(false)
                notification.success({
                  message: "操作成功",
                })
                props.onOk()
              } else {
                notification.error({
                  message: res.data?.msg || "操作失败，请稍后重试",
                })
              }
            })
            .catch(() => {
              notification.error({
                message: "请求异常，请稍后重试",
              })
            })
            .finally(() => {
              setConfirmLoading(false)
            })
        }}
        okText="确认提交"
        centered
        maskClosable={false}
      >
        <Row style={{ height: 50 }}>
          提交后请耐心等待工作人员审核
        </Row>
      </Modal>

      <PreviewImgOrPdf
        token={props.token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
